export interface Log {
  url: string;
  body: any;
  response: any;
}

const logs: Log[] = [];

const get = () => {
  return logs;
};

const add = (log: Log) => {
  logs.push(log);
};

const clear = () => {
  logs.length = 0;
};

export default {
  get,
  add,
  clear,
};
